import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { LogManager, ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

import {
    ENTITY_TAG_PICKER_SEARCH_ENTITY_TAGS
} from 'Redux/actionTypes';

import {
    entityTagPickerSearchEnityTagsResponse
} from 'Redux/actions';

function* entityTagPickerSearchEnityTagsRequest({ payload }) {
    const { filters } = payload;
    const { parentTagId, entityName, onlyTagsWithEntities } = filters;
    try {
        let response = {}
        let items = [];
        let total = 0;
        if (parentTagId !== 0) {
            response = yield call(
                clientQuery,
                `
                    query searchTagsAndEntities(
                        $parentTagIds: [Int], 
                        $entityName: String!, 
                        $openSearch: String,
                        $onlyEntities: Boolean,
                        $limit: Int, 
                        $offset: Int
                        $untaggedAccess: Boolean
                    ) {
                        entityTags: searchTagsAndEntities (
                            parentTagIds: $parentTagIds, 
                            entityName: $entityName, 
                            limit: $limit, 
                            offset: $offset,
                            openSearch: $openSearch,
                            onlyEntities: $onlyEntities,
                            untaggedAccess: $untaggedAccess
                        ) {
                            items {
                                name
                                id
                                label
                                color
                                disabled
                                parentTagId
                                tag {
                                    hasChildren
                                    unitsCount
                                    companiesCount
                                }
                            }
                            total
                        }
                    }
            `,
                {
                    parentTagIds: parentTagId ? [parentTagId] : [],
                    entityName: entityName,
                    limit: filters?.limit || 0,
                    offset: filters?.offset || 0,
                    openSearch: filters?.openSearch || "",
                    onlyEntities: false,
                    onlyTagsWithEntities: onlyTagsWithEntities
                },
                endpoints.GRAPHQL_GENERAL,
            );
        } else {
            response = yield call(
                clientQuery,
                `
                query searchTags($conditions: [TagSearchInput], $sort: [TagSortInput], $limit: Int, $offset: Int) {
                    entityTags: searchTags(
                        conditions: $conditions
                        sort: $sort
                        limit: $limit
                        offset: $offset
                    ) {
                        items {
                            id
                            color
                            label
                            unitsCount
                            companiesCount
                        }
                        total
                    }
                }
            `,
                {
                    conditions: [],
                    sort: {
                        field: "id",
                        order: "ASC"
                    },
                    limit: 1000,
                    offset: 0
                },
                endpoints.GRAPHQL_GENERAL,
            );
        }

        if (!response || !response.entityTags) {
            throw 'No entityTags data';
        }

        if (parentTagId !== 0) {
            items = response?.entityTags?.items || [];
            total = response?.entityTags?.total || 0;
        } else {
            items = response?.entityTags?.items || [];
            items = items.map(item => {
                let entityTag = { tag: { hasChildren: false, unitsCount: item.unitsCount, companiesCount: item.companiesCount }, name: "Tag", disabled :false, parentTagId: null, ...item };
                return entityTag;
            });
        }

        yield put(entityTagPickerSearchEnityTagsResponse({ items, total, parentTagId, entityName }));
    } catch (exc) {
        ExceptionManager(exc, 'modules/.common/components/EntityTagPicker/redux/saga.js', 'entityTagPickerSearchEnityTagsRequest');
        yield put(entityTagPickerSearchEnityTagsResponse({ items: [], total: 0, error: true, parentTagId, entityName }));
    }
}

function* watchMethods() {
    yield takeEvery(ENTITY_TAG_PICKER_SEARCH_ENTITY_TAGS, entityTagPickerSearchEnityTagsRequest);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}

